import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

function DistanceFilter({ distance, setDistance }) {
    const distances = [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1, 5, 10, 15, 20,50]; // distances in kilometers

    return (
        <FormControl variant="outlined" size="small" sx={{ minWidth: 150, ml: 5, backgroundColor: 'white' }}>
            <InputLabel sx={{ color: 'black', fontStyle: 'bold' }} id="distance-label">Select Distance (km)</InputLabel>
            <Select
                labelId="distance-label"
                value={distance}
                label="Select Distance (km)"
                onChange={(e) => setDistance(e.target.value)}
            >
                {distances.map((d) => (
                    <MenuItem key={d} value={d}>
                        {d} km
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

export default DistanceFilter;
